export const MAX_CONTENT_WIDTH = 720;
export const POST_TITLE_APPBAR_HEIGHT = 45;
